export type FormControlCustomOptions = {
	readonly disabled?: boolean;
	readonly calculationFormula?: string;
};

export interface FormColumnCustomOptions {
	[key: string]: FormControlCustomOptions;
}
